import { AzioniDichiarazione, Dichiarazione } from 'client/api/backend/schemas';
import { DeclarationFieldDto } from 'common/dto/declaration/DeclarationFieldDto';

/** Ritorna i campi json della dichiarazione con il cast corretto, o null se non presenti */
export function getFields(declaration: Dichiarazione | null | undefined) {
  return (declaration?.jsonCampi as any as DeclarationFieldDto[]) ?? null;
}
